import { render, staticRenderFns } from "./PcBackLink.vue?vue&type=template&id=3840de56&scoped=true"
import script from "./PcBackLink.vue?vue&type=script&lang=js"
export * from "./PcBackLink.vue?vue&type=script&lang=js"
import style0 from "./PcBackLink.vue?vue&type=style&index=0&id=3840de56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3840de56",
  null
  
)

export default component.exports